// 首页与导航：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动首页
export const mobile = Object.freeze({
  "mobile.category.all": "All Categories",
  "mobile.category.searchPlaceholder": "Search categories",
  "mobile.home.bulkUploadTitle": "Bulk upload supply and demand listings",
  "mobile.home.bulkUploadHint": "Upload one XLS or XLSX file at a time",
  "mobile.home.uploadAction": "Choose file",
  "mobile.home.cancel": "Cancel",
  "mobile.home.confirm": "Confirm",
  "mobile.home.bannerAlt": "Home banner",
  "mobile.home.serviceValues": "XSOU service values",
  "mobile.home.excellentService": "Excellent service",
  "mobile.home.continuousInnovation": "Continuous innovation",
  "mobile.home.winTogether": "Collaborative success",
  "mobile.home.sharedValue": "Shared value",
  "mobile.home.content": "Home content",
  "mobile.home.feedTabs": "Home content categories",
  "mobile.home.viewMode": "Product display mode",
  "mobile.home.twoColumns": "Two-column view",
  "mobile.home.listMode": "List view",
  "mobile.home.listEnd": "You have reached the end",
  "mobile.home.loadFailedReload": "Could not load data. Tap to retry",
  "mobile.home.noProducts": "No products to display",
  "mobile.home.filterClues": "Filter supply and demand listings",
  "mobile.home.filterSelectedCount": "Filter listings, {count} selected",
  "mobile.home.clueSearchPlaceholder":
    "Search brands, parts, types or suppliers",
  "mobile.home.clearSearch": "Clear search",
  "mobile.home.searchClues": "Search listings",
  "mobile.home.import": "Import",
  "mobile.home.filter": "Filter",
  "mobile.home.closeFilter": "Close filters",
  "mobile.home.sourceRegion": "Source region",
  "mobile.home.brand": "Brand",
  "mobile.home.brandInitial": "B",
  "mobile.home.collapse": "Collapse",
  "mobile.home.expand": "Expand",
  "mobile.home.reset": "Reset",
  "mobile.home.viewResults": "View results",
  "mobile.home.clear": "Clear",
  "mobile.home.loadFailedRetry": "Could not load data. Please retry",
  "mobile.home.reload": "Reload",
  "mobile.home.type": "Type",
  "mobile.home.capacity": "Capacity",
  "mobile.home.architecture": "Architecture",
  "mobile.home.speed": "Speed",
  "mobile.home.ballCount": "Ball count",
  "mobile.home.quantity": "Quantity",
  "mobile.home.unitPrice": "Unit price",
  "mobile.home.priceOnRequest": "Price on request",
  "mobile.home.noPartNumber": "No part number",
  "mobile.home.batch": "Batch",
  "mobile.home.stockLocation": "Stock location",
  "mobile.home.supplier": "Supplier",
  "mobile.home.publishedAt": "Published",
  "mobile.home.noClues": "No listings",
  "mobile.home.itemsSelected": " selected",
  "mobile.home.delete": "Delete",
  "mobile.home.review": "Review",
  "mobile.home.all": "All",
  "mobile.home.mainland": "Mainland China",
  "mobile.home.hongKongMacaoTaiwan": "Hong Kong, Macao & Taiwan",
  "mobile.home.allBrands": "All brands",
  "mobile.home.keyword": "Keyword",
  "mobile.home.tradeInfo": "Transactions",
  "mobile.home.clueInfo": "Supply & demand opportunities",
  "mobile.home.newOrder": "You have a new order!",
  "mobile.home.acceptOrder": "View order",
  "mobile.home.uploading": "Uploading...",
  "mobile.home.uploadSucceeded": "Upload complete",
  "mobile.home.uploadFailed": "Upload failed",
  "mobile.home.selectUploadFile": "Select a file to upload",
  "mobile.home.waitForUpload": "Please wait for the upload to finish",
  "mobile.home.importSucceeded": "Import complete",
  "mobile.home.importFailed": "Import failed",
  "mobile.home.importFailedRetry": "Import failed. Please try again later",
  "mobile.home.confirmDeletion": "Confirm deletion",
  "mobile.home.deleteSelectedConfirm": "Delete {count} selected listings?",
  "mobile.home.deleteSucceeded": "Deleted",
  "mobile.home.deleteFailedRetry": "Could not delete. Please try again later",
  "mobile.home.confirmReview": "Confirm review",
  "mobile.home.reviewSelectedConfirm": "Approve {count} selected listings?",
  "mobile.home.reviewSucceeded": "Review complete",
});

// 测试商城首页
export const testHome = Object.freeze({
  "pcCsHome.products": "Products",
  "pcCsHome.information": "Listings",
  "pcCsHome.imageView": "Grid view",
  "pcCsHome.tableView": "Table view",
  "pcCsHome.brandPlaceholder": "Enter a brand",
  "pcCsHome.partNumberPlaceholder": "Enter a part number",
  "pcCsHome.origin": "Origin",
  "pcCsHome.originPlaceholder": "Select an origin",
  "pcCsHome.supplierPlaceholder": "Enter a supplier",
  "pcCsHome.productType": "Product type",
  "pcCsHome.productTypePlaceholder":
    "Enter type, capacity, architecture, speed or ball count",
});

// 页脚
export const footer = Object.freeze({
  "pcFooter.logo": "XSOU logo",
  "pcFooter.email": "Email",
  "pcFooter.phone": "Phone",
  "pcFooter.wechat": "WeChat",
  "pcFooter.weibo": "Weibo",
  "pcFooter.taobao": "Taobao",
  "pcFooter.copyright":
    "Copyright © 2017-2026 XSOU (https://www.xsou.com) All Rights Reserved.",
  "pcFooter.company": "XSOU",
  "pcFooter.about": "About XSOU",
  "pcFooter.contact": "Contact us",
  "pcFooter.join": "Careers",
  "pcFooter.privacy": "Privacy notice",
  "pcFooter.help": "Help center",
  "pcFooter.services": "XSOU services",
  "pcFooter.supplierJoin": "Supplier onboarding",
  "pcFooter.supplyChainManagement": "Supply chain management",
  "pcFooter.supplyChainServices": "Supply chain services",
  "pcFooter.supplyChainFinance": "Supply chain finance",
  "pcFooter.products": "Products",
  "pcFooter.flash": "Flash memory",
  "pcFooter.memory": "DRAM",
  "pcFooter.embedded": "Embedded storage",
  "pcFooter.ssd": "SSDs",
  "pcFooter.memoryModule": "Memory modules",
  "pcFooter.usbFlashCard": "USB flash drives & cards",
  "pcFooter.gpuServer": "GPU servers",
  "pcFooter.chipNetwork": "XSOU chip network",
  "pcFooter.ai": "XSOU AI",
  "pcFooter.featuredChips": "Featured chips",
  "pcFooter.bidding": "Chip bidding",
  "pcFooter.supplyDemand": "Supply & demand",
  "pcFooter.directSales": "Direct sales",
  "pcFooter.wiki": "Chip wiki",
  "pcFooter.marketIndex": "Market index",
  "pcFooter.tools": "Tools",
  "pcFooter.ascTool": "ASC tool",
  "pcFooter.xmlTool": "XML tool",
});

// 桌面首页
export const desktop = Object.freeze({
  "pcHome.selectLoadedClues": "Select all loaded listings",
  "pcHome.contactPublisher": "Contact publisher {name}",
  "pcHome.publisherConsultationFailed": "Unable to open publisher consultation. Please retry.",
  "pcHome.marketNav": "Market",
  "pcHome.brandFallback": "Brand {number}",
  "pcHome.sortName": "Name",
  "pcHome.sortProducts": "Products",
  "pcHome.sortPopularity": "Popularity",
  "pcHome.bulkUploadTitle": "Bulk upload supply and demand listings",
  "pcHome.bulkUploadDescription":
    "Upload an Excel file in .xlsx or .xls format",
  "pcHome.chooseFile": "Choose a file to upload",
  "pcHome.cancel": "Cancel",
  "pcHome.confirm": "Confirm",
  "pcHome.confirmUpload": "Upload",
  "pcHome.searchPlaceholder": "Search part numbers or product names",
  "pcHome.searchAction": "Search",
  "pcHome.serviceValues": "XSOU service values",
  "pcHome.excellentService": "Excellent service",
  "pcHome.continuousInnovation": "Continuous innovation",
  "pcHome.winWinCooperation": "Win-win cooperation",
  "pcHome.sharedValue": "Shared value",
  "pcHome.ai": "XSOU AI",
  "pcHome.popularBrands": "Popular brands",
  "pcHome.moreBrands": "View more brands",
  "pcHome.brandsLoading": "Loading brands...",
  "pcHome.noBrands": "No brands available",
  "pcHome.scrollShortcutsLeft": "Scroll quick links left",
  "pcHome.scrollShortcutsRight": "Scroll quick links right",
  "pcHome.shortcutIcon": "Quick link icon",
  "pcHome.backToTop": "Back to top",
  "pcHome.shortcut.supplyDemand": "Supply & demand",
  "pcHome.shortcut.supply": "Supply",
  "pcHome.shortcut.demand": "Demand",
  "pcHome.shortcut.selfOperated": "Direct sales",
  "pcHome.shortcut.featured": "Featured",
  "pcHome.shortcut.bidding": "Bidding",
  "pcHome.shortcut.wiki": "Chip wiki",
  "pcHome.shortcut.marketIndex": "Market index",
  "pcHome.shortcut.traceability": "Testing & traceability",
  "pcHome.shortcut.training": "Training & certification",
  "pcHome.shortcut.brands": "Brands",
  "pcHome.importSupplyDemand": "Import listings",
  "pcHome.gridView": "Grid",
  "pcHome.cardView": "Cards",
  "pcHome.listView": "List",
  "pcHome.endOfList": "You've reached the end",
  "pcHome.loadFailedRetry": "Could not load data. Tap to retry",
  "pcHome.image": "Image",
  "pcHome.productImage": "Product image",
  "pcHome.brand": "Brand",
  "pcHome.brandInitial": "B",
  "pcHome.partNumber": "Part number",
  "pcHome.noPartNumber": "No part number",
  "pcHome.type": "Type",
  "pcHome.capacity": "Capacity",
  "pcHome.architecture": "Architecture",
  "pcHome.speed": "Speed",
  "pcHome.ballCount": "Ball count",
  "pcHome.price": "Price",
  "pcHome.unitPrice": "Unit price",
  "pcHome.quantity": "Quantity",
  "pcHome.publisher": "Posted by",
  "pcHome.noData": "No data available",
  "pcHome.filters": "Filters",
  "pcHome.brandLabel": "Brand:",
  "pcHome.all": "All",
  "pcHome.search": "Search",
  "pcHome.originLabel": "Origin:",
  "pcHome.mainland": "Mainland China",
  "pcHome.hongKongMacaoTaiwan": "Hong Kong, Macao & Taiwan",
  "pcHome.keywordLabel": "Keywords:",
  "pcHome.filterPlaceholder":
    "Search brand, part number, type, capacity, architecture, speed, ball count or supplier",
  "pcHome.reset": "Reset",
  "pcHome.query": "Search",
  "pcHome.loading": "Loading...",
  "pcHome.loadFailedRefresh": "Could not load data. Refresh and try again",
  "pcHome.reload": "Reload",
  "pcHome.batch": "Batch",
  "pcHome.goodsLocation": "Goods location",
  "pcHome.publishedAt": "Posted at",
  "pcHome.supplier": "Supplier",
  "pcHome.selectedCount": "{count} selected",
  "pcHome.delete": "Delete",
  "pcHome.review": "Review",
  "pcHome.searchBrand": "Search brands",
  "pcHome.brandNamePlaceholder": "Enter a brand name",
  "pcHome.searching": "Searching...",
  "pcHome.noMatchingBrands": "No matching brands",
  "pcHome.informationSaved": "Saved successfully. Awaiting review.",
  "pcHome.information": "Information review",
  "mobile.home.information": "Information review",
  "pcHome.tradeInfo": "Trade information",
  "pcHome.supplyDemandInfo": "Supply & demand opportunities",
  "pcHome.newMessages": "You have new messages!",
  "pcHome.viewMessages": "View messages",
  "pcHome.newOrders": "You have new orders!",
  "pcHome.acceptOrder": "View orders",
  "pcHome.uploading": "Uploading...",
  "pcHome.uploadSuccess": "Upload successful",
  "pcHome.uploadFailed": "Upload failed",
  "pcHome.chooseFileFirst": "Choose a file to upload",
  "pcHome.waitForUpload": "Wait for the upload to finish",
  "pcHome.importSuccess": "Import successful",
  "pcHome.importFailed": "Import failed",
  "pcHome.deleteConfirmTitle": "Confirm deletion",
  "pcHome.deleteConfirmMessage": "Delete these {count} records?",
  "pcHome.deleteSuccess": "Deleted successfully",
  "pcHome.deleteFailed": "Could not delete. Try again later",
  "pcHome.reviewConfirmTitle": "Confirm review",
  "pcHome.reviewConfirmMessage": "Review these {count} records?",
  "pcHome.reviewSuccess": "Review successful",
});

export const messages = Object.freeze({
  ...mobile,
  ...testHome,
  ...footer,
  ...desktop,
});
